export const routeRoles = [
  {
    path: /^\/(main_report|main_report_new)?$/, // Регулярка для '/', '/main_report', '/main_report_new'
    roles: ['fin_reports'],
  },
  {
    path: /^\/main_report/, // Пути, начинающиеся с '/main_report'
    roles: ['marketer'],
  },
  {
    path: /^\/fin/, // Все пути, начинающиеся с '/fin'
    roles: ['admin_fin', 'fin_expenses_read', 'fin_expenses_write'],
  },
  {
    path: /^\/trader_deposit_rub/, // Все пути, начинающиеся с '/trader_deposit_rub'
    roles: ['trader_deposit_rub'],
    default_path: '/trader_deposit_rub',
  },
  {
    path: /^\/fg/, // Все пути, начинающиеся с '/fg'
    roles: ['admin_deposit_rub'],
  },
  // Админ имеет доступ ко всему
  {
    path: /.*/, // Любой путь (универсальная регулярка)
    roles: ['admin'],
  },
];